import NavbarComponent from "./navbar";

import { useState } from "react";
import { useHistory } from "react-router-dom";
function Navbar() {
  const history = useHistory();
  const [clickMobile, setClickMobile] = useState(false);
  const [subMenu, setSubMenu] = useState();

  const handleClick = (props) => {
    if (clickMobile) {
      setClickMobile(false);
    } else {
      if (props?.link) {
        setSubMenu(props?.link);
      }
    }
  };

  const handleCloseSubMenu = () => {
    setSubMenu(undefined);
  };

  const handleMouseEnter = (subMenu) => {
    if (window.innerWidth < 960) {
      setSubMenu(undefined);
    } else {
      setSubMenu(subMenu);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth < 960) {
      setSubMenu(undefined);
    } else {
      setSubMenu(undefined);
    }
  };

  const handleClickLogo = () => () => {
    let path = "/";
    history.push(path);
    setClickMobile(false);
  };

  const handleClickMobile = () => () => {
    setClickMobile(!clickMobile);
  };

  return (
    <NavbarComponent
      subMenu={subMenu}
      clickMobile={clickMobile}
      onClick={handleClick}
      onClickLogo={handleClickLogo}
      onCloseSubMenu={handleCloseSubMenu}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      onClickMobile={handleClickMobile}
    />
  );
}

export default Navbar;
